document.addEventListener('DOMContentLoaded', () => {
  listenForAddJsAndRedirect();
});

function listenForAddJsAndRedirect() {
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
      const response = await originalFetch(input, init);
      const url = typeof input === 'string' ? input : input.url;

      if (url && url.includes('/cart/add.js')) {
          setTimeout(async () => {
              await window.Shopify.onItemAdded();
              document.querySelector('header a[href="/cart"]').click();
          }, 500);
      }

      return response;
  };
}
